import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "instagram",
  "use": "instagram-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"instagram\">\n  <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M4 0h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm4 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm4-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol